/**
 * @generated SignedSource<<4dc14187c4a8869af288f3d0b23a8253>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_SIDE_GENERATOR" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
import { FragmentRefs } from "relay-runtime";
export type serviceCreditsServiceCredit_fragment$data = {
  readonly serviceCredit: {
    readonly autoRefill: boolean;
    readonly credit: number;
    readonly hasSellerPurchasedCredits: boolean;
    readonly service: ServicesWithCredits;
    readonly serviceCreditID: number;
    readonly trialCreditsUsed: boolean;
    readonly unlimitedCredits: boolean;
  } | null;
  readonly " $fragmentType": "serviceCreditsServiceCredit_fragment";
};
export type serviceCreditsServiceCredit_fragment$key = {
  readonly " $data"?: serviceCreditsServiceCredit_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"serviceCreditsServiceCredit_fragment">;
};

import serviceCredits_fragmentServiceCreditQuery_graphql from './serviceCredits_fragmentServiceCreditQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "serviceName"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": serviceCredits_fragmentServiceCreditQuery_graphql
    }
  },
  "name": "serviceCreditsServiceCredit_fragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "serviceName",
          "variableName": "serviceName"
        }
      ],
      "concreteType": "ServiceCredit",
      "kind": "LinkedField",
      "name": "serviceCredit",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceCreditID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "service",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "credit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "autoRefill",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unlimitedCredits",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "trialCreditsUsed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasSellerPurchasedCredits",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "547ffe4161fad5900346da4c6927d8f9";

export default node;
